import(/* webpackMode: "eager" */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/app/[lang]/error.tsx");
